"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var stripe_js_1 = require("@stripe/stripe-js");
var react_1 = __importStar(require("react"));
var react_loading_skeleton_1 = __importDefault(require("react-loading-skeleton"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var localization_1 = require("../../../../checkout/localization");
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
var save_button_1 = require("../../../components/save_button");
var CreateSetupIntentStripeMutation = __importStar(require("../../../mutations/create-setup-intent-stripe"));
var UpdateCreditCardStripeMutation = __importStar(require("../../../mutations/update-credit-card-stripe"));
var billing_address_1 = __importDefault(require("./billing-address"));
var payment_1 = require("./payment");
var LoadingSkeletons = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null, "Credit Card"),
        react_1.default.createElement("div", { className: 'h-4' }),
        react_1.default.createElement(react_loading_skeleton_1.default, { height: 378 }),
        react_1.default.createElement("div", { className: 'h-4' }),
        react_1.default.createElement("div", null, "Billing Address"),
        react_1.default.createElement("div", { className: 'h-4' }),
        react_1.default.createElement(react_loading_skeleton_1.default, { height: 660 })));
};
var NOT_NOW_ERROR_MESSAGE = 'We are unable to update your payment method at this time. Please try again later or contact Customer Support if the problem persists.';
var LOAD_SETUP_INTENT_AND_STRIPE_QUERY_NAME = 'loadSetupIntentAndStripeQuery';
/** Allow the user to update their credit card information and billing address using Stripe as the payment processor */
var UpdateCreditCardStripe = function () {
    var _a = __read((0, react_1.useState)(), 2), errorMessage = _a[0], setErrorMessage = _a[1];
    // this gql mutation is called via useQuery rather than useMutation because we want to call it once and only once on the first render
    // we use react-query to load Stripe rather than passing the loading promise directly to Elements so that we can inspect
    // whether or not stripe has finished loading before deciding  before deciding to stop showing LoadingSkeleton
    var loadSetupIntentAndStripeQuery = (0, react_query_1.useQuery)([LOAD_SETUP_INTENT_AND_STRIPE_QUERY_NAME], function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, loadedStripe;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, api_1.getSubscriptionAPIClient)().request(CreateSetupIntentStripeMutation.query)];
                case 1:
                    result = _a.sent();
                    return [4 /*yield*/, (0, stripe_js_1.loadStripe)(result.createSetupIntentStripe.stripePublishableKey)];
                case 2:
                    loadedStripe = _a.sent();
                    return [2 /*return*/, { setupIntent: result.createSetupIntentStripe, loadedStripe: loadedStripe }];
            }
        });
    }); }, { onError: function () { return setErrorMessage(NOT_NOW_ERROR_MESSAGE); } });
    return (react_1.default.createElement("div", { className: 'margin-vertical-8 account-container update-credit-card-stripe-container' },
        react_1.default.createElement("div", { className: 'panel space-y-4' },
            loadSetupIntentAndStripeQuery.isLoading && (react_1.default.createElement("div", null,
                react_1.default.createElement(LoadingSkeletons, null))),
            loadSetupIntentAndStripeQuery.data && loadSetupIntentAndStripeQuery.data.loadedStripe && (react_1.default.createElement(react_stripe_js_1.Elements, { stripe: loadSetupIntentAndStripeQuery.data.loadedStripe, options: { clientSecret: loadSetupIntentAndStripeQuery.data.setupIntent.stripeClientSecret } },
                react_1.default.createElement(UpdateCreditCardStripeInner, __assign({}, { errorMessage: errorMessage, setErrorMessage: setErrorMessage })))),
            errorMessage && react_1.default.createElement("div", null, errorMessage))));
};
/** This component only exists so that it can be wrapped by the above component in Stripe's Elements provider */
var UpdateCreditCardStripeInner = function (_a) {
    var setErrorMessage = _a.setErrorMessage;
    var context = (0, react_1.useContext)(payment_1.PaymentContext);
    var _b = __read((0, react_1.useState)(false), 2), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var stripe = (0, react_stripe_js_1.useStripe)();
    var stripeElements = (0, react_stripe_js_1.useElements)();
    var queryClient = (0, react_query_1.useQueryClient)();
    var updateCreditCardStripeMutation = (0, react_query_1.useMutation)(function (variables) {
        return (0, api_1.getSubscriptionAPIClient)().request(UpdateCreditCardStripeMutation.query, variables);
    });
    var callout = (0, callout_1.useCallout)().callout;
    var history = (0, react_router_dom_1.useHistory)();
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!stripe || !stripeElements)
                        return [2 /*return*/]; // the UI should have prevented this
                    setIsSubmitting(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, stripe.confirmSetup({
                            elements: stripeElements,
                            confirmParams: { return_url: "".concat(window.location.protocol, "//").concat(window.location.host, "/account#/payment/update-card/failed") },
                            redirect: 'if_required',
                        })];
                case 2:
                    // North American card payment methods should never cause a redirect. If they do, this is a problem because we won't get a chance to call updateCreditCardStripeMutation.mutateAsync.
                    // For this reason, we've set the return_url as a failure page which asks the user to let CS know that this happened.
                    //
                    // If we ever need to support redirect-based payment methods, we can consider doing the following:
                    //   - Set "redirect" to "always" so that we don't have to support two separate flows: one for redirect and one for non-redirect based payment methods.
                    //   - Create a new mutation in subscriptions-api (updateSetupIntent) which encrypts a user's billing address (and any other sensitive information we need to complete the payment method update) and stores
                    //   the encrypted billing information on the Stripe setup intent. Stripe says that metadata should not contain PII, so encrypting the PII is a workaround for that.
                    //     - Note: alternatively, this mutation could update the payment method that's been created by the setup intent with the customer's billing details, but that would require that all of our billing
                    //     details flow through Stripe, with any nuances/conversions/validations that it may perform, rather than letting us store the billing details as a freeform (serialized) object in metadata and performing
                    //     the translation for Recharge and for Stripe from our own billing details object rather than having to convert from Stripe's object to Recharge's. This is particularly important with things like country
                    //     codes, where each service may have a different way of storing country identifiers.
                    //   - Call this new mutation on the client right before making this stripe.confirmSetup call. It's important that we wait for this new mutation complete before calling stripe.confirmSetup because
                    //   stripe.confirmSetup will perform a browser redirect whenever it wants to without additional input from us.
                    //   - Set up a new route to redirect the user to. Instead of just being a failure-only page, this would now be a completion page which inspects the Stripe setup intent to see if it succeeded,
                    //   and if so, sends the updateCreditCardStripeMutation mutation to subscriptions-api. This mutation would be modified though to not accept the customer's billing address, but rather
                    //   get the encrypted billing address from the setup intent and decrypt it. Then it would do whatever it currently does with the billing address as normal.
                    result = _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    console.error(error_1);
                    setErrorMessage(error_1);
                    setIsSubmitting(false);
                    return [2 /*return*/];
                case 4:
                    // Get ready for the unlikely case of an additional card update during the same load of this page by getting a new setup intent.
                    // Not awaiting this promise because we don't need to await the refetch.
                    void queryClient.invalidateQueries(LOAD_SETUP_INTENT_AND_STRIPE_QUERY_NAME);
                    return [7 /*endfinally*/];
                case 5:
                    if (result.error || !result.setupIntent) {
                        console.error(result.error);
                        setErrorMessage(((_a = result.error) === null || _a === void 0 ? void 0 : _a.message) || NOT_NOW_ERROR_MESSAGE);
                        setIsSubmitting(false);
                        return [2 /*return*/];
                    }
                    _b.label = 6;
                case 6:
                    _b.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, updateCreditCardStripeMutation.mutateAsync({
                            stripeSetupIntentId: result.setupIntent.id,
                            address1: context.address1,
                            address2: context.address2,
                            city: context.city,
                            company: context.company,
                            countryCode: localization_1.CountryToCodeMapping[context.country || 'United States'],
                            firstName: context.firstName,
                            lastName: context.lastName,
                            phone: context.phone,
                            state: context.province,
                            zip: context.zip,
                        })];
                case 7:
                    _b.sent();
                    return [3 /*break*/, 9];
                case 8:
                    err_1 = _b.sent();
                    console.error(err_1);
                    setErrorMessage(NOT_NOW_ERROR_MESSAGE);
                    setIsSubmitting(false);
                    return [2 /*return*/];
                case 9: 
                // it's unnecessary to setLoading(false) here because we'll be redirected away from
                // this route and the user won't see the loading indicator anymore
                return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                case 10:
                    // it's unnecessary to setLoading(false) here because we'll be redirected away from
                    // this route and the user won't see the loading indicator anymore
                    _b.sent();
                    callout.success('Updated Payment!');
                    history.replace('/payment');
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null, "Credit Card"),
            react_1.default.createElement("div", { className: 'h-4' }),
            react_1.default.createElement("div", { className: 'space-y-2' },
                react_1.default.createElement(react_stripe_js_1.PaymentElement, null))),
        react_1.default.createElement(billing_address_1.default, null),
        react_1.default.createElement(save_button_1.SaveButton, { disabled: !stripe || !stripeElements, isLoading: isSubmitting, onClick: onSubmit })));
};
exports.default = UpdateCreditCardStripe;
